module.exports = __webpack_public_path__ + "static/1347259240-1.7f1d4268.jpg";